import { IOS_PHONE, PHONE } from "constants/deviceInfo";
import { useDeviceInfo } from "hooks/useDeviceInfo";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { keepInAppLinksInSameTab } from "util/keepInAppLinksInSameTab";

// On phones, installs the same-tab link override using the router's history.
export const KeepInAppLinksInSameTab = (): null => {
  const history = useHistory();
  const { device } = useDeviceInfo();
  const isMobileDevice = device === PHONE || device === IOS_PHONE;

  useEffect(() => {
    if (!isMobileDevice) return;

    return keepInAppLinksInSameTab(history.push);
  }, [history, isMobileDevice]);

  return null;
};
